import React from "react";
import TotalRankingComponent from "../../components/totalRankingComponents/TotalRankingComponent";

export interface TotalRankingContainerProps {
    isTabSelected: boolean
}


const TotalRankingContainer: React.FC<TotalRankingContainerProps> = ({isTabSelected}) => {
    return (<TotalRankingComponent isTabSelected={isTabSelected} />);
};

export default TotalRankingContainer;
